import { Fragment } from 'react';
import Layout from '../../components/layout/layout.component';

const Navigation = () => {
    return (
        <Fragment>
            <Layout />
        </Fragment>
    );
};

export default Navigation;
